var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38332",
    "data-name": "Group 38332",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.982,
    height: 33.896,
    viewBox: "0 0 35.982 33.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.987,0l9,16.948-9,16.948H9L0,16.948,9,0Z",
    transform: "translate(0 0)",
    fill: "#ca4b5c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37995",
    "data-name": "Group 37995",
    transform: "translate(9.745 8.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65383",
    "data-name": "Path 65383",
    d: "M9.583,1a8.583,8.583,0,1,0,8.583,8.583A8.592,8.592,0,0,0,9.583,1Zm3.34,9.016L7.77,12.8a.493.493,0,0,1-.726-.433V6.8a.491.491,0,0,1,.726-.433L12.923,9.15A.492.492,0,0,1,12.923,10.016Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.2dcf8f2c4be17b4527bf8034323d7b25.svg";
export { ForwardRef as ReactComponent };